import React from 'react';
import styled from 'styled-components';
import {
  Stat, IconType,
} from '@routific/hive';
import { useTranslation } from 'react-i18next';
import { MiniRouteContainerType } from './MiniRouteInfo';
import { GaugeSizeTypes } from './WorkingTimeInfo';
import TooltipBody from '../../shared/TooltipBody';
import { DistanceUnit } from '../../../store/mst/models';

interface Props {
  totalDistance: number;
  unit: DistanceUnit;
  large?: boolean;
  type?: MiniRouteContainerType;
  gaugeSize?: GaugeSizeTypes;
  loading?: boolean;
  disabled?: boolean;
}

const DistanceInfoItem = styled.div<{ $large?: boolean }>`
  min-width: 0;
  display: flex;
  align-items: center;
`;

const DistanceInfo: React.FC<Props> = ({
  totalDistance, unit, large, type, gaugeSize, loading = false, 
  disabled,
}) => {
  const { t } = useTranslation('components');
  const unitString = unit === DistanceUnit.KM ? 'km' : 'mi';
  const string = loading ? '--' : `${totalDistance + unitString}` || `0${unitString}`;
  return (
    <DistanceInfoItem
      className="item"
      data-cy={type && `${type}-route-utilization-distance`}
      $large={large}
    >
      <Stat
        size={gaugeSize}
        label={{ value: string }}
        percent={null}
        icon={IconType.Distance}
        tooltipContent={<TooltipBody text={t('routeDetailsPanel.stats.labels.distance')} />}
        disabled={disabled}
      />
    </DistanceInfoItem>
  );
};

export default DistanceInfo;
